import { useForkRef } from "@mui/material";
import React, { forwardRef, useEffect, useRef } from "react";
import { ListProps } from "react-virtuoso";
import { AutocompleteListbox } from "../TimeInputSlots";

export const VirtuosoList = forwardRef<HTMLDivElement, ListProps>(({ style, children }, listRef) => {
  const currRef = useRef<HTMLElement>(null);
  const setRefs = useForkRef(currRef, listRef);
  useEffect(() => {
    if (
      style?.visibility &&
      currRef.current &&
      currRef.current.parentElement?.parentElement?.hasAttribute("data-virtuoso-scroller")
    ) {
      currRef.current.parentElement!.parentElement!.style.width =
        currRef.current.getBoundingClientRect().width + 20 + "px";
    }
  }, [style?.visibility]);

  return (
    // `margin` is already zeroed in `AutocompleteListbox`'s own styles. Repeating it inline put a
    // shorthand next to the `marginTop` Virtuoso positions the window with, which React warns about and
    // which overwrote that offset. Only the padding has to be beaten here, and Virtuoso's own style wins.
    <AutocompleteListbox ref={setRefs} style={{ padding: 0, ...style }}>
      {children}
    </AutocompleteListbox>
  );
});
VirtuosoList.displayName = "VirtuosoList";
